import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { HTML_LINK_TARGET } from '../../../constants/html'
import {
  useContentOverflow,
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
} from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { FloatingTooltip } from '../../Floating'
import { getUserLinkProps } from '../User.utils'
import { UserMultiValueContent } from '../UserMultiValueContent'

import { getUserMultiValueContentLinkedTooltip } from './UserMultiValueContentLinked.utils'

import * as styles from './UserMultiValueContentLinked.module.css'

function UserMultiValueContentLinked({
  getTooltip = getUserMultiValueContentLinkedTooltip,
  link,
  name,
  target = HTML_LINK_TARGET.blank,
  user,
  ...restProps
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const tooltip = getTooltip({ t, value: name })

  const { LinkComponent, userLink } = getUserLinkProps({
    isExternalContactProfileNGAvailable,
    isProviderProfileNGAvailable,
    isUserProfileNGAvailable,
    link,
    user,
  })

  return (
    <FloatingTooltip
      content={tooltip}
      disabled={!tooltip && !overflow}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <LinkComponent
        {...userLink}
        className={styles.link}
        ref={setContentOverflowRef}
        rel='noreferrer'
        target={target}
        onClick={stopPropagation}
      >
        <UserMultiValueContent
          {...restProps}
          name={name}
          textClassName={styles.text}
          tooltipDisabled={!!tooltip}
          user={user}
        />
      </LinkComponent>
    </FloatingTooltip>
  )
}

export default UserMultiValueContentLinked
